<div class='contact'>
    <section>
        <h2>Do you have a general concern?</h2>
        <h2>Fill out the form below.</h2>

        <form [formGroup]="contactForm" (ngSubmit)="submitContact($event)">
            <input type="text" placeholder="Your Name" value="" formControlName="from_shopper">
            <input type="text" placeholder="Your Email" value="" formControlName="email">
            <input type="text" placeholder="Title" value="" formControlName="title">
            <textarea name="" placeholder="Your Message" id="" cols="30" rows="10" formControlName="message"></textarea>
            <button [disabled]="!contactForm.valid">Submit</button>
            <div class="loading" *ngIf="submitted==='loading'">
                <img src="../../assets/img/ExcessMaterialLoading.png" alt="">
                <h1>SENDING...</h1>
            </div>
            <div *ngIf="submitted==='submitted'">
                <h1>SUCCESS!</h1>
            </div>
        </form>
    </section>
 
</div>